import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { EstabelecimentoAtivo } from "app/modules/registers/estabelecimentos/dto/estabelecimento-ativo.types";
import { EstabelecimentosAtivosService } from "app/modules/registers/estabelecimentos/services/estabelecimentos-ativos.service";
import { LookupModel, Pagination } from "app/shared/models";
import { EncripterService } from "app/shared/services";
import { Subject, takeUntil } from "rxjs";
import { EzvLookupComponent } from "../ezv-lookup/ezv-lookup.component";
import { AuthService } from "app/core/auth/auth.service";

@Component({
  selector: "app-empresa-ativa",
  template: `
    <ng-container *transloco="let t">
      <app-lookup
        [service]="_service"
        [entity]="active"
        (update)="setActive($event)"
        class="block w-80"
        [editing]="false"
        [loadOnOpen]="true"
        [showLabel]="showLabel"
        label="estabelecimentos.selecionarEmpresaAtiva"
      >
      </app-lookup>
    </ng-container>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: "empresaAtiva",
  imports: [TranslocoModule, EzvLookupComponent],
})
export class EzvEmpresaAtivaComponent implements OnInit, OnDestroy {
  @Output() update = new EventEmitter<LookupModel>();

  @Input() showLabel = false;

  active: LookupModel;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected _unsubscribeAll: Subject<any> = new Subject<any>();
  private _changeDetectorRef: ChangeDetectorRef;
  private _service: EstabelecimentosAtivosService;
  private _encriptor: EncripterService;
  private _authService: AuthService;

  entities: LookupModel[];

  constructor() {
    this._changeDetectorRef = inject(ChangeDetectorRef);
    this._service = inject(EstabelecimentosAtivosService);
    this._encriptor = inject(EncripterService);
    this._authService = inject(AuthService);
  }

  ngOnInit(): void {
    this._service
      .getAll({
        size: null,
        page: 0,
        sortOrder: "ASC",
        sort: "codigo",
      } as Pagination)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response) => {
        const list: EstabelecimentoAtivo[] = response?.data ?? [];

        this.entities = list?.map((e: EstabelecimentoAtivo) => {
          return { id: e.id, description: e.razaoSocial } as LookupModel;
        });

        this.active = this.getActive();

        if (this.active) {
          this.entities = [this.active];
        } else if (list.length > 0) {
          this.active = {
            id: list.at(0).id,
            description: list.at(0).razaoSocial,
          } as LookupModel;

          this.setActive(this.active);
        }

        this._changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  setActive(obj: LookupModel): void {
    if (!obj || !obj.description) {
      return;
    }

    this._service.setActive(obj);

    this._authService.atualizaEstabelecimento(obj.id).subscribe((resp) => {
      if (resp.success) {
        this._authService.accessToken = resp.data.token;
        this.update.emit(obj);
        location.reload();
      }
    });
  }

  getActive(): LookupModel {
    const plain = localStorage.getItem("activeEstabelecimento") ?? "";
    if (!plain) {
      return null;
    }

    try {
      return JSON.parse(this._encriptor.get(null, plain));
    } catch (e) {
      return null;
    }
  }
}
